import { FormikErrors, FormikTouched } from 'formik';
import * as Yup from 'yup';
import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import * as Interfaces from 'interfaces';
import { constants, logger } from 'utils';
import { Step as Done } from '../Done';
import { Step as VisitVictoria } from '../VisitVictoria';
import { DefaultErrorResponse } from 'utils/constants';
import { submitForm } from 'services/voucherService';
import { serializeForm } from './helpers';
import Component from './Review';

type Values = Partial<Interfaces.Common.FormValues>;

const initialValues: Values = {};
const initialErrors: FormikErrors<Values> = {};
const initialTouched: FormikTouched<Values> = {};

// const wizardSchema = Yup.bool().required().oneOf([true], 'Please tick this box to proceed.');
const wizardSchema = {};

const validationSchema = Yup.object().shape<Values>({});

const Step: StepProps<Values> = {
  id: 'review',
  title: constants.Page.title,
  stepName: 'Review',
  Component,
  validation: {
    schema: validationSchema,
    fieldNames: []
  },
  navigation: {
    normal: [
      {
        content: 'Back',
        type: 'secondary',
        shouldValidate: false,
        onClick: (wizardContext, form, appStates) => {
          const appContext = appStates[constants.StorageKeys.State] as Interfaces.Store.AppContext;
          appContext.actions.updateError();
          wizardContext.dispatch({
            type: 'GOTO_STEP',
            stepId: VisitVictoria.id,
            values: form.values
          });
        }
      },
      {
        content: 'Submit',
        shouldValidate: true,
        isSubmit: true,
        type: 'primary',
        onClick: async (context, form, appStates) => {
          const appContext = appStates[constants.StorageKeys.State] as Interfaces.Store.AppContext;
          try {
            form.setSubmitting(true);
            const result = await submitForm(
              serializeForm(
                form.values as Interfaces.Common.FormValues,
                appContext.currentState.transactionID
              )
            );

            if (result === 'TECHNICAL_ERROR') {
              appContext.actions.updateError({
                title: DefaultErrorResponse.title,
                value: "It looks like we couldn't process your submission. Please try again."
              });
              window.location.reload();
            } else if (result === 'TOO_LATE') {
              window.location.href = constants.Routes.QuotaExceeded.substring(1);
            } else if (result === 'TOO_EARLY') {
              logger.warn(
                'User is getting 412 from submitting before transaction is meant to be open'
              );
              window.location.href = constants.Routes.Home.substring(1);
            } else {
              context.dispatch({
                type: 'GOTO_STEP',
                stepId: Done.id
              });
            }
          } catch (e) {
            logger.error('Submit form error', e);
            appContext.actions.updateError({
              title: DefaultErrorResponse.title,
              value: 'Please try again later.'
            });
          }
          form.setSubmitting(false);
        }
      }
    ]
  }
};

export { Step, initialValues, initialTouched, initialErrors, wizardSchema };
